import { useNavigate } from '@tanstack/react-router';
import { motion } from 'motion/react';
import { RiHome5Line, RiArrowLeftLine } from '@remixicon/react';
import { Button } from '@/components/ui/button';

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center min-h-screen p-4 bg-background">
      <div className="max-w-3xl mx-auto space-y-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="space-y-6"
        >
          <h1 className="text-[10rem] md:text-[14rem] font-black leading-none text-foreground/90 select-none">
            404
          </h1>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="mb-8 -mt-32"
        >
          <img
            src="/nodata.svg"
            alt="Page not found"
            className="w-64 h-64 mx-auto opacity-80"
          />
        </motion.div>

        <motion.div
          className="space-y-3"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
        >
          {/* <h2 className="text-3xl font-bold text-foreground">Page Not Found</h2> */}
          <p className="max-w-md mx-auto text-lg text-muted-foreground">
            The page you are looking for does not exist. It might have been moved or deleted.
          </p>
        </motion.div>

        <motion.div
          className="flex flex-col justify-center gap-3 pt-4 sm:flex-row"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6 }}
        >
          <Button
            variant="outline"
            size="lg"
            onClick={() => window.history.back()}
            className="gap-2"
          >
            <RiArrowLeftLine className="size-4" />
            Go Back
          </Button>
          <Button
            size="lg"
            onClick={() => navigate({ to: '/dashboard' })}
            className="gap-2"
          >
            <RiHome5Line className="size-4" />
            Back to Dashboard
          </Button>
        </motion.div>
      </div>
    </div>
  );
}
